module.exports = __webpack_public_path__ + "img/cms_datasets.e310ea3d.png";